import { FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import { VehiclesHistoricalRow } from "../../fields-upload/VehiclesHistoricalRow";
import { formatDateAndTime } from "../../../../../../common/helpers/date.helpers";
import { IMaintenanceVisualRecord } from "../../../../../../types/maintenance-visual-record.type";

type CardDeliveredProps = {
  data: IMaintenanceVisualRecord;
  onClick?: () => void
  showDeliveredDetails?: boolean;
}

export default function CardEndMaintenance(props: CardDeliveredProps) {

  const [, setvehicleId] = useState<string | null>(null);
  const formik = useFormik({
    initialValues: {
      endMaintenance: [
        props.data.photosMaintenance[0].endMaintenance.find(endMaintenance => endMaintenance.type === 'Odômetro'),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ] as any,
      // outras propriedades inicializadas aqui
    },
    onSubmit: (values) => { values },
    // outras opções do Formik aqui
  });

  const endDateAt = props.data.endAt ? formatDateAndTime(props.data.endAt.toString()) : '';

  useEffect(() => {
    setvehicleId(props.data.vehicleId);
  }, [props.data]);

  return (
    <FormikProvider value={formik}>
      <div className="flex flex-col z-0 items-center bg-gray2/20 m-1 p-1 pt-4 rounded shadow-md border-b border-gray2 cursor-pointer overflow-hidden h-64" onClick={props.onClick}>
        {formik.values?.endMaintenance?.map((doc, index) => (
          <div key={index} className={`flex flex-col space-y-2 p-3 my-0 rounded ${index % 2}`}>
            <VehiclesHistoricalRow
              name={`endMaintenance.${index}`}
              initialData={doc || {}}
              prefix="devolucao"
              vehicleId={props.data.vehicleId}
            />
          </div>
        ))}

        <p className="text-[.9rem] text-black mx-auto">Finalizado em:</p>
        <p className="text-[.9rem] text-black mx-auto">{endDateAt}</p>
      </div>
    </FormikProvider>
  )
}



